export const StudioImages = [
    {
        original: 'https://i.ibb.co/TBvFGKz/IMG-20210702-175121.jpg',
        thumbnail: 'https://i.ibb.co/GvxbDsg/IMG-20210702-175121.jpg',
    },
    {
        original: 'https://i.ibb.co/SPS79Jy/IMG-20210702-162040.jpg',
        thumbnail: 'https://i.ibb.co/37KYLkd/IMG-20210702-162040.jpg',
    },
    {
        original: 'https://i.ibb.co/SKwLCch/DSC-0081.jpg',
        thumbnail: 'https://i.ibb.co/ZhzZDSn/DSC-0081.jpg',
    },
    {
        original: 'https://i.ibb.co/LpZ3Jyr/DSC-0110.jpg',
        thumbnail: 'https://i.ibb.co/pXLSRTQ/DSC-0110.jpg',
    },
];